import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Artists from "../pages/artists/page";
import YouTubeNetwork from "../pages/youtube/page";
import Services from "../pages/services/page";
import ServiceDetailPage from "../pages/services/ServiceDetailPage";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/youtube-network",
    element: <YouTubeNetwork />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/artists",
    element: <Artists />,
  },
  
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetailPage />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
